export var SOLID_COLOR_STYLE_NAME = 'solid-color';
export var SOLID_COLOR_CLASS = "is-style-".concat(SOLID_COLOR_STYLE_NAME);
//# sourceMappingURL=shared.js.map